import classNames from "classnames";
import { ReactChild, ReactNode } from "react";

import Spinner from "components/Spinner";
import "./AdminPanel.css";

type Title = {
  prefix?: string;
  main: string | ReactNode;
  suffix?: string;
};

type AdminPanelProps = {
  title: Title;
  oppositeTitle?: Title;
  canOverflow?: boolean;
  isSaving?: boolean;
  actions?: ReactNode;
  djangoLink?: ReactNode;
  children: ReactChild;
};

const AdminPanel = ({
  title,
  oppositeTitle,
  canOverflow,
  isSaving,
  actions,
  djangoLink,
  children,
}: AdminPanelProps) => {
  return (
    <div className={classNames("Panel", { "Panel--overflow": canOverflow })}>
      {isSaving && (
        <div className="Panel__spinner">
          <Spinner />
        </div>
      )}
      <header className="panelTitle__container">
        <div className="panelHeader">
          {title.prefix && (
            <p className="panelHeader__prefix">{title.prefix}</p>
          )}
          <h2 className="panelHeader__mainTitle">{title.main}</h2>
        </div>
        {oppositeTitle && (
          <div className="panelHeader panelHeader--opposite">
            {oppositeTitle.prefix && (
              <p className="panelHeader__prefix">{oppositeTitle.prefix}</p>
            )}
            <h2 className="panelHeader__mainTitle">{oppositeTitle.main}</h2>
          </div>
        )}
        <div className="panelTitle__actions">
          {actions}
          {djangoLink}
        </div>
      </header>
      {children}
    </div>
  );
};

export default AdminPanel;
